import Vue from "vue";
import moment from "moment-jalaali";

Vue.filter('timeAgo', value => moment(value).fromNow());
Vue.filter('longDate', value => moment(value).format('jYYYY-jMM-jDD HH:mm:ss'));
Vue.filter('onlyTime', value => moment(value).format('HH:mm:ss'));
Vue.filter('onlyDate', value => moment(value).format('jYYYY-jM-jD'));
Vue.filter('rial', value => value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
Vue.filter('stringDate', function (input) {
  try {
    // let moment = require('moment-jalaali')
    moment.locale("fa", null);
    moment.loadPersian({dialect: 'persian-modern'});
    return moment(input, 'YYYY-M-D HH:mm:ss').format('dddd LL HH:mm:ss');
  } catch (e) {
  }
})


Vue.filter('persianNum', function (input) {
  try {
    if (input === undefined || input == null) return "";
    let str1 = input.toString().trim();
    if (str1 === '') return '';
    str1 = str1.replace(/0/img, '۰');
    str1 = str1.replace(/1/img, '۱');
    str1 = str1.replace(/2/img, '۲');
    str1 = str1.replace(/3/img, '۳');
    str1 = str1.replace(/4/img, '۴');
    str1 = str1.replace(/5/img, '۵');
    str1 = str1.replace(/6/img, '۶');
    str1 = str1.replace(/7/img, '۷');
    str1 = str1.replace(/8/img, '۸');
    str1 = str1.replace(/9/img, '۹');
    return str1;
  } catch (e) {
  }
})


Vue.filter('userType', value => {
  if (value === 'legal')
    return 'شخص حقوقی';
  return 'شخص حقیقی';
})
Vue.filter('isEmpty', val => {
  return val ? val : '';
})
Vue.filter('status', val => {
  if (val === 'active')
    return 'فعال';
  else if (val === 'inactive')
    return 'غیر فعال';
  else
    return 'نامعلوم'
})


Vue.filter('requestStatus', val => {
  if (val === 'pending')
    return 'در انتظار تایید';
  else if (val === 'accept')
    return 'تایید شده';
  else if (val === 'reject')
    return 'رد شده';
  else
    return 'نامعلوم'
})


Vue.filter('callStatus', val => {
  if (val === 'BUSY')
    return 'اشغال';
  else if (val === 'CONGESTION')
    return 'ازدحام';
  else if (val === 'NO ANSWER')
    return 'عدم پاسخ';
  else if (val === 'ANSWERED')
    return 'پاسخ داده شده';
  else
    return 'نامعلوم'
})


Vue.filter('transactionType', val => {
  if (val === 'withdraw')
    return {
      label: 'برداشت',
      color: '#ff4000'
    };
  else if (val === 'deposit')
    return {
      label: 'واریز',
      color: '#23a400'
    };
  else if (val === 'refund')
    return {
      label: 'بازگشت وجه',
      color: '#23a400'
    };
  else if (val === 'charge')
    return {
      label: 'شارژ کیف پول',
      color: '#23a400'
    };
  else if (val === 'adminCharge')
    return {
      label: 'تراکنش توسط ادمین',
      color: '#23a400'
    };
  else if (val === 'agency')
    return {
      label: 'عاملیت',
      color: '#23a400'
    };
  else
    return {
      label: 'نامعلوم',
      color: '#23a400'
    }
})

Vue.filter('serviceTypeNumber', val => {
  switch (val) {
    case 1:
      return 'ترمینال تبلیغات';
    case 2:
      return 'پیامک لند';
    case 3:
      return 'کیوآر لند';
    case 4:
      return 'ربات لند';
    case 5:
      return 'بیلبورد';
    case 6:
      return 'تبلیغ نگار';
    case 7:
      return 'حمل و نقل';
    case 8:
      return 'ملی';
    case 9:
      return 'رسانه های تصویری';
    case 10:
      return 'بانک اطلاعاتی';
    case 11:
      return 'املاک';
    case 13:
      return 'سایت';
    case 14:
      return 'گرافیک';
    case 22:
      return 'مدیریت فروشگاه های آنلاین';
    default:
      return 'نامعلوم';
  }

})


Vue.filter('serviceType', val => {
  if (val === 'Payamakland')
    return 'پیامک لند';
  else if (val === 'Coreland')
    return 'کورلند';
  else if (val === 'Qrland')
    return 'کیوآر لند';
  else if (val === 'Robotland')
    return 'ربات لند';
  else if (val === 'billboard')
    return 'بیلبورد';
  else if (val === 'tablighNegar')
    return 'تبلیغ نگار';
  else if (val === 'Transport')
    return 'حمل و نقل';
  else if (val === 'Meli')
    return 'ملی';
  else if (val === 'Media')
    return 'رسانه های تصویری';
  else if (val === 'Info')
    return 'بانک اطلاعاتی';
  else if (val === 'RealEstate')
    return 'املاک';
  else if (val === 'Digi')
    return 'سایت';
  else if (val === 'AIGenerator')
    return 'هوش مصنوعی';
  else if (val === 'Qrlandshop')
    return 'مدیریت فروشگاه های آنلاین';
  else
    return 'نامعلوم'
})


Vue.filter('isEmpty', value => {
  return value ? value : ""
})

Vue.filter('persianNumber', value => {
  return value.toPersianLetter();
})


Vue.filter('numericPersianNumber', value => {
  if (value < 1_000_000)
    return value / 1_000 + " هزار"
  return value / 1_000_000 + " میلیون"
});

Vue.filter('productName', value => {
  switch (value) {
    case 'FREE PAYMENT':
      return 'خرید آزاد';
    case 'NUMBER':
      return 'خرید شماره';
    case 'UNIQUE':
      return 'خرید متن غیرتکراری';
    case 'SLOT':
      return 'خرید جایگاه سیم‌کارت';
    case 'REPORT':
      return 'گزارش';
    case 'CHAT':
      return 'چت اتوماتیک';
    case 'NEW':
      return 'تازه های دیوار';
    default:
      return 'تعریف نشده!'
  }
})

Vue.filter('adminType', value => {
  if (value === 'admin') {
    return 'مدیر';
  } else if (value === 'online') {
    return 'آنلاین';
  } else if (value === 'refund') {
    return 'تراکنش اصلاحی';
  } else if (value === 'agency') {
    return 'عاملیت';

  } else if (value === 'deposit') {
    return 'واریز';

  } else if (value === 'withdraw') {
    return 'برداشت';
  } else {
    return 'ثبت نشده!';
  }
})
